export const genExecTime = (seconds: number, comma?: boolean) => {
  const end = parseInt(seconds.toString(), 10);
  let endMins: string | number = parseInt((end / 60).toString(), 10);
  let endSeconds: string | number = parseInt(
    (end - endMins * 60).toString(),
    10,
  );
  if (endMins.toString().length === 1) endMins = '0' + endMins;
  if (endSeconds.toString().length === 1)
    endSeconds = '0' + endSeconds;
  const separator = comma ? ',' : ':';
  const extraSymbol = comma ? '' : '00:';
  return `${extraSymbol}${endMins}${separator}${endSeconds}`;
};
